import type { Viewport } from '../hex/camera2d';
import type { HexMapState } from './renderer';
import { DEFAULT_MODAL_THEME } from '../../modal/ui/ModalTheme';

export function drawModals(
    ctx: CanvasRenderingContext2D,
    state: HexMapState,
    viewport: Viewport,
): void {
    if (state.modals.length === 0) return;

    const theme = DEFAULT_MODAL_THEME;

    state.modals.forEach((modal, index) => {
        modal.actionRects = [];
        modal.render(ctx, state, viewport, theme);

        if (index !== state.modals.length - 1) {
            ctx.save();
            ctx.fillStyle = 'rgba(0,0,0,0.18)';
            ctx.fillRect(modal.rect.x + 2, modal.rect.y + 2, modal.rect.w, modal.rect.h);
            ctx.restore();
        }
    });
}
